import { spacing } from "./spacing";

const divPadding = spacing.xl;

export const constants = {
  radius: {
    view: 10,
    card: 25,
    button: 50,
  },
  form: {
    shouldDirty: true,
    shouldValidate: true,
  },
  chart: {
    projection: {
      width: 320,
      height: 140,
      barRadius: 2,
    },
    performance: {
      width: 425,
      height: 160,
      strokeWidth: 2,
      nodes: 80,
    },
  },
  divPadding,
} as const;
